import CategorySvgOffice from "assets/common/category-icons/office.svg?react";
import CategorySvgOperation from "assets/common/category-icons/operation.svg?react";
import CategorySvgOther from "assets/common/category-icons/other.svg?react";
import CategorySvgScope from "assets/common/category-icons/scope.svg?react";
import CategorySvgSupport from "assets/common/category-icons/support.svg?react";
import CategorySvgTotal from "assets/common/category-icons/total.svg?react";
import CategorySvgTransport from "assets/common/category-icons/transport.svg?react";
import CategorySvgUsage from "assets/common/category-icons/usage.svg?react";
import { FunctionComponent, SVGProps } from "react";

enum DisplayTypes {
  byCategory = "category",
  byScope = "scope",
  total = "total",
}

interface Style {
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  color: string;
  subcategoryColors?: { [key: string]: string };
}

const CategoryStyles: { [key: string]: Style } = {
  total: { Icon: CategorySvgTotal, color: "#6C63FF" },
  usage: {
    Icon: CategorySvgUsage,
    color: "#9898BC",
    subcategoryColors: {
      datacenter: "#726F93",
      network: "#837FA9",
      device: "#9898BC",
    },
  },
  operation: {
    Icon: CategorySvgOperation,
    color: "#20B2AA",
    subcategoryColors: {
      event: "#165958",
      external: "#166F6D",
      internal: "#168B86",
      downstream_delivery: "#20B2AA",
    },
  },
  support: {
    Icon: CategorySvgSupport,
    color: "#4B50F7",
    subcategoryColors: {
      furniture: "#252079",
      other_support: "#2B269B",
      upstream_delivery: "#372BD7",
      production: "#4B50F7",
      industrial_equipment: "#5E79F3",
      product_use: "#7C92F6",
      product_eol: "#A0B7FF",
    },
  },
  office: {
    Icon: CategorySvgOffice,
    color: "#FFA620",
    subcategoryColors: {
      food: "#B74606",
      energy: "#DD6702",
      building: "#FFA620",
      waste: "#FFA620",
      cleaning: "#FBBD46",
    },
  },
  transport: {
    Icon: CategorySvgTransport,
    color: "#F93A55",
    subcategoryColors: {
      trips: "#C8082D",
      commute: "#F93A55",
    },
  },
  other: {
    Icon: CategorySvgOther,
    color: "#6E91C2",
    subcategoryColors: {
      investment: "#6E91C2",
      other_gas: "#4C74AB",
      without_category: "#6E91C2",
    },
  },
  scope_1: { Icon: CategorySvgScope, color: "#6C63FF" },
  scope_2: { Icon: CategorySvgScope, color: "#F93A55" },
  scope_3: { Icon: CategorySvgScope, color: "#FFA620" },
};

export { CategoryStyles, DisplayTypes };
